import { render, staticRenderFns } from "./patrolPlaceItem.vue?vue&type=template&id=65dd70c3"
import script from "./patrolPlaceItem.vue?vue&type=script&lang=js"
export * from "./patrolPlaceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65dd70c3')) {
      api.createRecord('65dd70c3', component.options)
    } else {
      api.reload('65dd70c3', component.options)
    }
    module.hot.accept("./patrolPlaceItem.vue?vue&type=template&id=65dd70c3", function () {
      api.rerender('65dd70c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrolPlaceItem.vue"
export default component.exports